import { render } from "./PhoneMange.vue?vue&type=template&id=c1c9a9ca&scoped=true"
import script from "./PhoneMange.vue?vue&type=script&lang=js"
export * from "./PhoneMange.vue?vue&type=script&lang=js"

import "./PhoneMange.vue?vue&type=style&index=0&id=c1c9a9ca&lang=scss&scoped=true"
import "./PhoneMange.vue?vue&type=style&index=1&id=c1c9a9ca&lang=scss"

import exportComponent from "/Users/opm/opm-vue-pc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c1c9a9ca"]])

export default __exports__